import { useState, useEffect, useCallback } from 'react';
import { AUTH_EVENT_NAME, AuthEventType } from '../events/constants';
import { emitter } from '../events/emitter';

export const useAuthEvents = (subscribeTo: AuthEventType[] = []) => {
    const [eventsQueue, setEventsQueue] = useState<AuthEventType[]>([]);
    /**
     * get the last event that caused a rerender, and optionally consume the event to remove it from the queue
     * (will cause an update)
     * @returns
     */
    const getLatestEvent = () => {
        const [event, ...restOfEvents] = eventsQueue;
        return {
            event: event as typeof event | undefined,
            consumeEvent: () => setEventsQueue(restOfEvents),
        };
    };
    const clearQueue = useCallback(() => {
        setEventsQueue([]);
    }, []);

    useEffect(() => {
        emitter.on(AUTH_EVENT_NAME, (event: AuthEventType) => {
            if (subscribeTo.includes(event)) {
                setEventsQueue([...eventsQueue, event]);
            }
        });
    }, [subscribeTo, eventsQueue]);
    return { eventsQueue, getLatestEvent, clearQueue, setEventsQueue };
};
